export const pickup_failure_reasons = [
    "Shop closed",
    "Not ready",
    "Cancelled by customer",
    "Wrong address",
    "Wrong phone",
    "Wrong packages",
]